import { Button } from "@mui/joy";
import { memo } from "react";
import ErrorReport from "./ErrorReport";

interface SnackbarErrorReportButtonProps {
  origin: string;
  error: string;
  details: string;
  closeSnackbar: () => void;
}

const SnackbarErrorReportButton = memo<SnackbarErrorReportButtonProps>(
  ({ origin, error, details, closeSnackbar }) => {
    return (
      <ErrorReport
        details={details}
        error={error}
        onComplete={closeSnackbar}
        origin={origin}
        renderTrigger={(openDialog) => (
          <Button
            onClick={openDialog}
            size="sm"
            sx={{
              "--Button-minHeight": "24px",
              borderRadius: "2px",
              lineHeight: 1,
              paddingInline: "0.5rem",
            }}
          >
            Report issue to Decentriq
          </Button>
        )}
      />
    );
  }
);
SnackbarErrorReportButton.displayName = "SnackbarErrorReportButton";

export default SnackbarErrorReportButton;
